<template>
  <div class="collaborator">
    <div class="collaborator-details-section">
      <img v-if="hasIcon()" class="profile-picture" :src="companion.image_url" alt="" />
      <div v-if="!hasIcon()">
        <div class="profile-picture initials-profile">
          {{ companion.name ? companion.name.firstName[0] : companion.email[0].toUpperCase() }}
        </div>
      </div>
      <div class="companion-details">
        <div class="companion-name">
          {{ name() }}
        </div>
        <div class="companion-status">
          {{ status() }}
        </div>
      </div>
    </div>
    <div v-if="isOwner && companion.type === 'suggestion'">
      <button class="resend-button" @click.prevent="addCompanion" v-bind:disabled="invite">Invite</button>
    </div>
    <div v-if="isOwner && companion.type === 'collaborator'" class="actions">
      <button class="remove-companion" @click.prevent="removeCollaborator" v-bind:disabled="removed">Remove</button>
    </div>
    <div v-if="isOwner && companion.type === 'invitation'" class="actions">
      <button class="resend-button" @click.prevent="resendInvition" v-bind:disabled="resend">Resend</button>
      <button class="remove-button" @click.prevent="removeCollaborator" v-bind:disabled="removed">
        <div class="remove-icon">&nbsp;</div>
      </button>
    </div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';
import axios from 'axios';

export default {
  name: 'Companion',
  components: {},
  props: {
    isSuggestion: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: String,
      required: true,
    },
    isOwner: {
      type: Boolean,
      default: false,
    },
    tripId: {
      type: String,
      required: true,
    },
    companion: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      removed: false,
      resend: false,
      invite: false,
    };
  },
  methods: {
    fullName() {
      if (!this.companion.name) {
        return '';
      }
      return `${this.companion.name.firstName} ${this.companion.name.lastName}`;
    },
    name() {
      return this.companion.name ? this.fullName() : this.companion.email;
    },
    status() {
      if (this.companion.type === 'invitation') {
        return 'Invitation Pending';
      }
      if (this.companion.type === 'owner') {
        return 'Trip Owner';
      }
      if (this.companion.type === 'suggestion' && this.companion.otherTripCount > 0) {
        return `Companion on ${this.companion.otherTripCount} other trip${this.companion.otherTripCount > 1 ? 's' : ''}`;
      }
      return 'Companion';
    },
    hasIcon() {
      return this.companion.image_url && this.companion.image_url.length > 0;
    },
    getPostBody(resend = false) {
      return {
        email: this.companion.email,
        ownerId: this.userId,
        tripId: this.tripId,
        resend,
      };
    },
    debounce() {
      setTimeout(() => {
        this.removed = false;
        this.resent = false;
        this.invite = false;
        this.email = '';
      }, 3000);
    },
    addCompanion() {
      this.invite = true;
      this.$emit('addCompanion', this.getPostBody());
    },
    async resendInvition() {
      this.resent = true;
      this.debounce();
      console.log('resendInvition');
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
      const res = await axios.post(`${process.env.VUE_APP_API2}inviteCollaborator`, this.getPostBody(true), {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${user.signInUserSession.idToken.jwtToken}`,
        },
      });
      console.log('res', res);
      this.$bvToast.toast('Invitation Resent!', {
        title: 'Resend Invitations',
        autoHideDelay: 3000,
        appendToast: this.append,
      });
    },
    async removeCollaborator() {
      this.removed = true;
      this.debounce();
      console.log('removeCollaborator');
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
      const res = await axios.post(`${process.env.VUE_APP_API2}removeCollaborator`, this.getPostBody(), {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${user.signInUserSession.idToken.jwtToken}`,
        },
      });
      console.log('res', res);
      this.$bvToast.toast('Companion Removed!', {
        title: 'Companion List',
        autoHideDelay: 3000,
        appendToast: this.append,
      });

      this.$emit('collaboratorRemoved', this.companion.email);
    },
  },
};

</script>

<style scoped lang="scss">
.collaborator {
  display: flex;
  align-items: center;
  padding: 16px 24px;
  height: 72px;
  min-width: 100%;
  background-color: #E8EBEC;
  border-radius: 8px;
  justify-content: space-between;

  @media screen and (max-width: 600px) {
    padding: 8px 12px;
  }
}

.actions {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
}

.companion-details {
  display: flex;
  flex-shrink: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex-direction: column;
  gap: 4px;
}

.collaborator-details-section {
  display: flex;
  // flex-shrink: 1;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  flex-grow: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

}

.companion-name {
  font-family: 'IdealSans-Bold';
  font-size: 18px;
  line-height: 19.2px;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.companion-status {
  font-family: 'IdealSans-Light';
  font-size: 12px;
  line-height: 14.4px;
}


.profile-picture {
  grid-area: profile-picture;
  width: 40px;
  height: 40px;
  border: solid 2px #fff;
  border-radius: 50%;
}

.initials-profile {
  width: 40px;
  height: 40px;
  margin-top: 10px;
  border: solid 3px #fff;
  border-radius: 50%;
  background-color: rgb(0, 48, 73);
  font-family: "susa-bold";
  color: #ffffff;
  font-size: 24px;
  position: relative;
  top: -8px;
  padding-top: 9px;
  z-index: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: inline-flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-items: center;
}

button.remove-companion {
  color: #C60000;
  background: transparent;
  border: 2px solid #C60000;
  border-radius: 5px;
  font-family: 'klinicslabbold';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  padding: 8px 24px;

}

button.resend-button {
  border-radius: 5px;
  border: 1px solid #4E97B2;
  background: #173945;
  color: #F6F4EE;
  font-family: 'klinicslabbold';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  padding: 8px 24px;

  &:hover {
    box-shadow: 0 0 3px #003049;
  }
}

button.remove-button {
  background-color: transparent;
  background-position: center;
  border: none;
  cursor: pointer;
  margin-top: 4px;
}

.remove-icon {
  background-image: url('/images/icons/remove.svg');
  background-color: transparent;
  background-size: 25px;
  width: 25px;
  background-repeat: no-repeat;

  &:hover {
    background-image: url('/images/icons/remove-hover.svg');
  }
}
</style>
